import { Box, Fade, Stack } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { ECounterType } from "@tm/models"
import { TmaHelper } from "@tm/utils"
import { memo, useMemo } from "react"
import { Icon } from "../../../../muiStyled/DataDisplay/Icons"
import { Tooltip } from "../../../../muiStyled/DataDisplay/tooltip"
import { ArticleNumbers } from "../../ArticleNumbers"
import { CompactAttributes } from "../../Attributes/CompactAttributes"
import { BonusSystem } from "../../BonusSystem"
import { useDefaultArticleItemState } from "../../ContextProviderStates/DefaultArticleItemState"
import { Descriptions } from "../../Descriptions"
import { DefaultArticleErpContainer } from "../../ErpContainer"
import { FavoriteArticles } from "../../FavoriteArticles"
import { Image } from "../../Image"
import { Supplier } from "../../Supplier"
import { Transactions } from "../../Transactions"
import { ExpandIconButton } from "./ArticleItemComponents"
import { Attributes } from "../../Attributes"
import { InformationAreaActions } from "../../Actions/InformationAreaActions"
import { DetailsButton } from "../../Actions/DetailsButton"
import { AdditionalInformations } from "../../AdditionalInformations"
import { DmsArticleInformation } from "../../Dms/DmsArticleInformation"
import { References } from "../../References"
import { Notifications } from "../../Notifications"
import { Selection } from "../../Actions/Selection"
import AlreadyOrderedArticle from "../../Vouchers/AlreadyOrderedArticle"
import { TileWrapper } from "../../StyledComponents"

export const TileArticleContentComponent = memo(() => {
    const toggleExpand = useDefaultArticleItemState((x) => x.toggleExpand)
    const expanded = useDefaultArticleItemState((x) => x.expanded)
    const articleOrder = useDefaultArticleItemState((x) => x.articleOrder)
    const articleOrdered = useDefaultArticleItemState((x) => x.alreadyOrdered)
    const dmsInformation = useDefaultArticleItemState((x) => x.dmsArticleInfo)
    const { hasFavoriteArticles, highlightFavoriteArticlesButton } = useDefaultArticleItemState((x) => x.options)
    const { translateText } = useLocalization()

    return useMemo(() => {
        const handleExpand = () => {
            TmaHelper.GeneralCountEvent.Call(ECounterType.ArticleListExpandArticle, true)
            toggleExpand()
        }

        return (
            <TileWrapper expanded={expanded} order={articleOrder || 0}>
                <Stack spacing="0.5em">
                    {/* BonusSystem, Article Image, Supplier */}
                    <Stack flexDirection="row" justifyContent="space-between">
                        <Stack flexDirection="column" spacing={0.5} position="relative">
                            <DetailsButton />
                            <BonusSystem />
                        </Stack>
                        <Image size={140} marginTop={1} boxShadow="none" />
                        <Stack flexDirection="column" spacing={0.5}>
                            <Selection />
                        </Stack>
                    </Stack>
                    <Stack flexDirection="row" alignItems="end" justifyContent="space-between">
                        <Stack alignItems="start" height="70px" maxWidth="calc(100% - 30px)" paddingLeft="0.5rem">
                            <Supplier />
                            <ArticleNumbers />
                            <Descriptions oneLine />
                        </Stack>
                        {/* Expand Icon */}
                        <Tooltip title={translateText(expanded ? 13862 : 12569)}>
                            <ExpandIconButton onClick={handleExpand} hoverEffect disableRipple>
                                <Icon name={expanded ? "minus" : "plus"} />
                            </ExpandIconButton>
                        </Tooltip>
                    </Stack>

                    {expanded ? (
                        <>
                            <Attributes />
                            <Fade in unmountOnExit mountOnEnter appear={false}>
                                <Box>
                                    <References />
                                    <AdditionalInformations />
                                    <Notifications />
                                </Box>
                            </Fade>
                            <InformationAreaActions />
                            {articleOrdered && <AlreadyOrderedArticle />}
                            <DmsArticleInformation dmsArticleInfo={dmsInformation} />
                        </>
                    ) : (
                        <CompactAttributes />
                    )}
                </Stack>
                {/* Actions, ERP Infos */}
                <Stack spacing={2}>
                    {hasFavoriteArticles && highlightFavoriteArticlesButton ? (
                        <Stack direction="row" justifyContent="end">
                            <FavoriteArticles />
                        </Stack>
                    ) : (
                        <>
                            <DefaultArticleErpContainer />
                            <Transactions displayMoreMenuButton />
                        </>
                    )}
                </Stack>
            </TileWrapper>
        )
    }, [expanded, articleOrder, translateText, articleOrdered, dmsInformation, hasFavoriteArticles, highlightFavoriteArticlesButton, toggleExpand])
})
